/*
 * Consent gate for the cart page — see snippets/afaq-terms-consent.liquid.
 *
 * Two things make a naive inline script wrong here:
 *   1. the consent block is printed above the checkout button, so at parse
 *      time #checkout does not exist yet;
 *   2. Dawn re-renders the cart sections through the Section Rendering API on
 *      every quantity change and assigns the result with innerHTML, which
 *      replaces the checkbox and the button and never runs injected <script>
 *      tags again.
 *
 * So: no element references are cached, the listeners are delegated to
 * document, and a childList observer re-applies the state after each
 * re-render. Only childList is observed — sync() changes attributes, and
 * observing those would make it retrigger itself.
 */
(function () {
  var BOX = '[data-afaq-consent-box]';
  var ERROR = '[data-afaq-consent-error]';

  function consentBox() {
    return document.querySelector(BOX);
  }

  function sync() {
    var box = consentBox();
    if (!box) return; // not the cart page

    var agreed = box.checked;
    var checkout = document.getElementById('checkout');
    var express = document.querySelector('.cart__dynamic-checkout-buttons');
    var error = document.querySelector(ERROR);

    if (checkout) checkout.disabled = !agreed;
    if (express) express.classList.toggle('afaq-consent-locked', !agreed);
    if (error && agreed) error.hidden = true;
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches && event.target.matches(BOX)) sync();
  });

  // Safety net: catch a submit that reaches the form another way — the Enter
  // key, or a button re-enabled by a re-render before sync() catches up.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.id !== 'cart') return;

    var box = consentBox();
    if (!box || box.checked) return;

    var submitter = event.submitter;
    if (submitter && submitter.name !== 'checkout') return; // quantity update

    event.preventDefault();
    var error = document.querySelector(ERROR);
    if (error) error.hidden = false;
    box.focus();
  });

  function start() {
    sync();
    var scope = document.querySelector('.cart__footer') || document.body;
    if (scope && window.MutationObserver) {
      new MutationObserver(sync).observe(scope, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
